import CloseRounded from '@mui/icons-material/CloseRounded';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';

import DonutChart from '../donutChart';
import DonutLegendItem from '../donutLegendItem';
import { useIntl } from 'react-intl';

export default function DonutCardModal({
  open,
  onClose,
  title,
  data = [],
  total = 0,
  centerValue = true,
}) {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          borderRadius: 2,
          height: '85vh',
          maxHeight: '85vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          fontWeight: 700,
        }}
      >
        {title}

        <IconButton
          aria-label={intl.formatMessage({
            id: 'dashboard.new.operation.close',
          })}
          onClick={onClose}
          size="small"
        >
          <CloseRounded />
        </IconButton>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'minmax(360px, 1.25fr) minmax(280px, 1fr)',
            },
            alignItems: 'center',
            gap: 3,
            height: '100%',
          }}
        >
          <DonutChart
            data={data}
            total={total}
            showCenterValue={centerValue}
            maxWidth={600}
            minimumLabelPercentage={3}
          />

          <Stack
            spacing={1.25}
            sx={{
              width: '100%',
              maxHeight: '100%',
              minHeight: 0,
              overflowY: 'auto',
              pr: 1,
            }}
          >
            {data.map((item, index) => (
              <DonutLegendItem
                key={item.key || `${item.name}-${index}`}
                item={item}
              />
            ))}
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
